export default __webpack_public_path__ + "base-site/media/getFetch.5fde86e3.cjs";